export class SoProductionStatusDetails {
    poNumber: string;
    orderCases: string;
    fgCases: string;
    completedPercentage: string;
}